import { Money } from '@/models/money';

export const getMoneyAsString = (money: Money) => {
    switch (money.currency) {
        case 'EUR':
            return `€ ${new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(money.amount)}`;
        default:
            return money.amount;
    }
};

export const addUpCosts = (costs: Money[], startValue = 0): number =>
    costs.reduce(
        (accumulator, current) => accumulator + current.amount,
        startValue
    );
